import { createSlice } from "@reduxjs/toolkit";
import { getAllPickerUserAction, getPickerUserAction, insertUpdatePickerUserAction, PickerUserChangeStatusACTION } from "../../actions/settingActions/pickerUserActions";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";

const INITIAL_STATE = {
    PickerUser: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedPickerUser: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdatePickerUser: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    deletePickerUser: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const PickerUserReducer = createSlice({
    name: "PickerUser",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetPickerUserDetailsState(state, action) {
            state.selectedPickerUser = INITIAL_STATE.selectedPickerUser;
            state.insertUpdatePickerUser = INITIAL_STATE.insertUpdatePickerUser;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllPickerUserAction.fulfilled, (state, action) => {
            // console.log("action.payload.data", action.payload);
            state.PickerUser.data = action.payload.data;
            state.PickerUser.apiMsg.status = action.meta.requestStatus;
            state.PickerUser.apiMsg.message = "success";
            // console.log( "state.PickerUser.data",  state.PickerUser.data.records);
        });
        builder.addCase(getAllPickerUserAction.pending, (state, action) => {
            state.PickerUser.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllPickerUserAction.rejected, (state, action) => {
            state.PickerUser.apiMsg.message = action.error.message;
            state.PickerUser.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getPickerUserAction.fulfilled, (state, action) => {
            state.selectedPickerUser.data = action.payload.data;
            state.selectedPickerUser.apiMsg.status = action.meta.requestStatus;
            state.selectedPickerUser.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getPickerUserAction.pending, (state, action) => {
            state.selectedPickerUser.data = null;
            state.selectedPickerUser.apiMsg.message = action.meta.requestStatus;;
            state.selectedPickerUser.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getPickerUserAction.rejected, (state, action) => {
            state.selectedPickerUser.apiMsg.message = action.error.message;
            state.selectedPickerUser.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(
            insertUpdatePickerUserAction.fulfilled,
            (state, action) => {
                // state.insertUpdatePickerUser.data = action.payload.data.data;
                if (action.meta.arg) {
                    const newData = action.meta.arg;
                    const existingRecords = state.PickerUser.data.records;
                    const index = existingRecords ? existingRecords.findIndex(record => record.userID === newData.userID) : -1;

                    if (!newData.userID) {
                        newData.userID = action.payload.data.data;
                    }
                    if (index !== -1) {
                        existingRecords[index] = {
                            ...existingRecords[index],
                             ...newData,
                        };
                    }
                    else {
                        if(newData.CheckuserType == Enums.UserType.MasterAdmin || newData.CheckuserType == Enums.UserType.MasterAdminUser){
                            if(newData.businessID == newData.filterBusinessID){
                                existingRecords.push(newData);
                                state.PickerUser.data.totalRecords = state.PickerUser.data.totalRecords + 1;
                            }
                        }else{
                            existingRecords.push(newData);
                            state.PickerUser.data.totalRecords = state.PickerUser.data.totalRecords + 1;
                        }
                    }
                    state.PickerUser.data.records = existingRecords;

                    state.insertUpdatePickerUser.data = {
                        userID: newData.userID,
                        firstName: newData.firstName,
                        lastName: newData.lastName,
                        userName: newData.userName,
                        roleID: newData.roleID,
                        roleName: newData.roleName,
                        active: newData.active,
                    };
                }

                state.insertUpdatePickerUser.apiMsg.status = action.meta.requestStatus;
                state.insertUpdatePickerUser.apiMsg.message = action.payload.message.message;
                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
        );
        builder.addCase(
            insertUpdatePickerUserAction.pending,
            (state, action) => {
                state.insertUpdatePickerUser.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdatePickerUserAction.rejected,
            (state, action) => {

                state.insertUpdatePickerUser.apiMsg.message = action.error.message;
                state.insertUpdatePickerUser.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );


        builder.addCase(PickerUserChangeStatusACTION.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                const existingRecords = state.PickerUser.data.records;
                const roleIdToDelete = action.payload.data.Id;
                const updatedRecords = existingRecords.filter(record => record.userID !== roleIdToDelete);
                state.PickerUser.data.records = updatedRecords;
                state.PickerUser.data.totalRecords = state.PickerUser.data.totalRecords - 1;
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Active) {
                const newData = action.meta.arg;
                const existingRecords = state.PickerUser.data.records;

                const index = existingRecords.findIndex(record => record.userID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: true,
                    };
                }
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Inactive) {
                const newData = action.meta.arg;
                const existingRecords = state.PickerUser.data.records;

                const index = existingRecords.findIndex(record => record.userID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: false,
                    };
                }

            }
            state.deletePickerUser.apiMsg.status = action.meta.requestStatus;
            state.deletePickerUser.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(PickerUserChangeStatusACTION.pending, (state, action) => {
            state.deletePickerUser.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(PickerUserChangeStatusACTION.rejected, (state, action) => {
            state.deletePickerUser.apiMsg.message = action.error.message;
            state.deletePickerUser.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET, ResetPickerUserDetailsState } = PickerUserReducer.actions;
export default PickerUserReducer.reducer;
